<template>
  <modal :name="`modal-search-custom-options-${product.sku}`" :width="450">
    <p class="h3" slot="header">
      {{ $t('Order configurator') }}
    </p>
    <div slot="content">
      <product-custom-options :product="product" />
      <div class="row center-xs">
        <add-to-cart class="col-xs-12 col-sm-4 col-md-6 list-button h5 py10 center-xs"
                     :product="productToAdd"
                     :disabled="!productToAdd"
        />
      </div>
    </div>
  </modal>
</template>
<script>
  import ProductCustomOptions from 'theme/components/core/ProductCustomOptions.vue'
  import Modal from 'theme/components/core/Modal.vue'
  import AddToCart from 'theme/components/core/AddToCart'

  export default {
    name: 'Configurator',
    components: {
      ProductCustomOptions,
      Modal,
      AddToCart
    },
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        productToAdd: null
      }
    },
    mounted () {
      this.productToAdd = this.product
      this.$bus.$on('product-after-customoptions', this.onAfterCustomOptionsChanged)
    },
    methods: {
      onAfterCustomOptionsChanged (payload) {
        let priceDelta = 0
        let priceDeltaInclTax = 0
        let optionsToProduct = []
        for (const optionValue of Object.values(payload.optionValues)) {
          optionsToProduct.push(optionValue)
          if (typeof optionValue === 'object' && parseInt(optionValue.option_type_id) > 0) {
            if (optionValue.price_type === 'fixed' && optionValue.price !== 0) {
              priceDelta += optionValue.price
              priceDeltaInclTax += optionValue.price
            }
            if (optionValue.price_type === 'percent' && optionValue.price !== 0) {
              priceDelta += ((optionValue.price / 100) * product.price)
              priceDeltaInclTax += ((optionValue.price / 100) * product.priceInclTax)
            }
          }
        }

        this.productToAdd = Object.assign({}, this.product, { selected_options: optionsToProduct })
        this.productToAdd.price = this.product.price + priceDelta
        this.productToAdd.originalPriceInclTax = this.product.priceInclTax + priceDeltaInclTax
        this.productToAdd.regular_price = this.product.priceInclTax + priceDeltaInclTax
        this.productToAdd.priceInclTax = this.product.priceInclTax + priceDeltaInclTax
      }
    },
    beforeDestroy() {
      this.$bus.$off('product-after-customoptions', this.onAfterCustomOptionsChanged)
    }
  }
</script>
